import { Typography } from "@mui/material";

import PermissionWrapper from "../../../global/PermissionWrapper";
import MenuDropDownButton from "../../../ui library/components/buttons/MenuDropDownButton";
import Svg, { SvgEnum } from "../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../ui library/HNSColors";
import { STYLES } from "../utils/customStyles";

import SearchBar from "./Fields/SearchBar";

export default function ContactsActions({ permissions, menuList }) {
  return (
    <div className="flex flex-row items-baseline justify-between">
      <SearchBar />
      <PermissionWrapper permission={permissions.ADD}>
        {menuList?.menuListItems?.length > 0 && (
          <MenuDropDownButton
            menuList={menuList}
            sx={STYLES.menuDropdownButtonStyle}
            className="group min-w-[240px] rounded-[500px] px-4 font-normal normal-case"
          >
            <div className="flex flex-row items-center justify-end gap-8 p-2">
              <Typography className="text-normal text-center text-sm font-normal group-hover:font-semibold">
                Add Contact
              </Typography>
              <Svg
                name={SvgEnum.HisPlusCircle}
                color={HNSColors.neutrals[900]}
                sx={{ height: "24px", width: "24px" }}
              />
            </div>
          </MenuDropDownButton>
        )}
      </PermissionWrapper>
    </div>
  );
}
